export default __webpack_public_path__ + "static/media/fileUpload.fbaf25a1.png";